<template>

<div>
  <b-sidebar
    id="sidebar-invoice-add-new-customer"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
    v-model="isSidebarActive"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h4 class="mb-0">
          {{  $t("Add client") }}
        </h4>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- Body -->

      <ValidationObserver ref="form">
        <BForm class="p-2">
          <BFormRadioGroup v-if="parent=='invoice'" class="d-flex col-12" v-model="clientType" >
            
            <BFormRadio  class="pr-1" v-for="p in clientOptions" :key="p.text" :value="p.value" >{{ p.text }} </BFormRadio>
          </BFormRadioGroup>

          <BRow class="m-0">
            <h4 class="pt-2"> Datos generales</h4>
          </BRow>

          <BRow>
            <TextInputValidated vsName="Nombre (razón social)" :vsModel.sync="client.name" vsLabel="name" vsMd="6" vsRequired vsRules="required" />
            <TextInputValidated vsName="First surname" :vsModel.sync="client.first_surname" vsLabel="first_surname" vsMd="6" v-if="showSurnames" :vsRequired = "showSurnames ? false : true" :vsRules="showSurnames ? 'required' : ''" />
            <TextInputValidated vsName="Second surname" :vsModel.sync="client.second_surname" vsLabel="second_surname" vsMd="6" v-if="showSurnames"/>
            <TextInputValidated vsName="Phone" :vsModel.sync="client.phone" vsLabel="phone" vsMd="6" vsRequired vsRules="required" />
            <TextInputValidated vsName="Email" :vsModel.sync="client.email" vsLabel="email" vsMd="12" vsRequired vsRules="required" />
            
          </BRow>

          <BRow class="m-0">
            <h4 class="pt-2"> Dirección</h4>
          </BRow>

          <BRow>
            <TextInputValidated vsName="Address" :vsModel.sync="client.address" vsLabel="address" vsMd="12" vsRequired vsRules="required" />
            <TextInputValidated vsName="City" :vsModel.sync="client.city" vsLabel="city" vsMd="6" vsRequired vsRules="required" />
            <NumberInputValidated vsName="Postal code" :vsModel.sync="client.postal_code" vsLabel="postal_code" vsMd="6" vsRequired vsRules="required" />
            <VSelectValidated vsName="Province" :vsModel.sync="client.province_id" :vsOptions="provinces" :vsReduce="province=> province.id" vsLabel="name"  vsRequired vsRules="required" vsMd="6"/>
            <VSelectValidated vsName="Country" :vsModel.sync="client.country_id"  :vsOptions="countries" :vsReduce="country=> country.id" vsLabel="name"  vsRequired vsRules="required" vsMd="6"/>
          </BRow>
          
          <BRow class="m-0">
            <h4 class="pt-2"> {{ $t("Aditionial information") }}</h4>
          </BRow>

          <BRow>
            <TextInputValidated vsName="TIN" :vsModel.sync="client.dni" vsLabel="dni" vsMd="6" vsRequired vsRules="required" />
            <VSelectValidated v-if="clientType=='account'" vsName="Forma jurídica" :vsModel.sync="client.customer_type_id" :vsOptions="customer_types" :vsReduce="customer_type=> customer_type.id" vsLabel="name" vsRequired vsRules="required" vsMd="6"/>
            <CheckboxValidated v-if="showIsLegalEntity && clientType=='account'" vsName="is_legal_entity" :vsModel.sync="client.is_legal_entity" vsLabel="Es entidad legal" />
            <CheckboxValidated v-if="clientType=='account'" vsName="is_legal_entity" :vsModel.sync="client.emit_face" vsLabel="Emitir factura electrónica" />
            <TextInputValidated vsName="Cuenta bancaria" :vsModel.sync="client.bank_account" vsLabel="bank_account" vsMd="12" vsRequired vsRules="required" />
            <VSelectValidated v-if="clientType=='account'" vsName="Método de pago" :vsModel.sync="client.payment_method_id" :vsOptions="paymentMethodsOptions" :vsReduce="method=> method.id" vsLabel="name"  vsRequired vsRules="required" vsMd="12"/>
            <VSelectValidated v-if="clientType=='student' && groups.length>1" vsName="Groups" :vsModel.sync="client.groups" :vsOptions="groups" vsLabel="name"  vsRequired vsRules="required" vsMultiple vsMd="12"/>
            <DatepickerValidated v-if="clientType=='student'" vsName="Start date" :vsModel.sync="client.start_date"  vsRequired vsRules="required" />
            <DatepickerValidated v-if="clientType=='student'" vsName="End date" :vsModel.sync="client.end_date" :vsMin="client.start_date" />
          </BRow>    
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit" @click.prevent="submit">
                <span v-if="clientType=='student'"> Añadir estudiante </span>
                <span v-else> Añadir cuenta </span>
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                @click="hide"
              >
              {{ $t("Cancel") }}
              </b-button>
            </div>
        </BForm>
    </ValidationObserver>
    </template>
  </b-sidebar>

  <!-- Modal: Añadir usuario existente a sucursal -->
  <BModal ref="clientMatchModal" centered size="lg" :title="'Alumno/a encontrado/a: ' + client.dni  " hide-footer>
      <div v-if="matchclient">
          <div class="pt-2">
              <h4 class="text-uppercase">¿Quieres añadir a este/a alumno/a a tu sucursal?</h4>
          </div>
          <div class="py-4">
              <BCard border-variant="secondary">
                  <BMedia vertical-align="center">
                    <template #aside>
                      <BAvatar size="50">
                          <FeatherIcon size="40" icon="UserIcon" />
                      </BAvatar>
                    </template>
                    <p class="font-weight-bold d-block text-nowrap m-0"> {{ matchclient.full_name }} <small class="text-muted" v-if="matchclient.username != null"> @{{ matchclient.username }}</small> </p>
                    <p class="m-0"><small class="text-muted">{{ matchclient.email }}</small></p>
                    <p class="m-0"><small class="text-muted">{{ matchclient.address }} | {{ matchclient.phone }}</small></p>
                  </BMedia>
              </BCard>
          </div>
          <div>
              <BButton variant="primary" @click="addToGroup(matchclient.id)">Aceptar</BButton>
              <BButton variant="danger" @click="clientMatchModal.hide()">Cancelar</BButton>
          </div>
      </div>
  </BModal>

  <!-- Modal: Aviso de usuario ya existente -->
  <BModal ref="clientMatchModalWarning" :title="'Alumno/a encontrado/a: ' + client.dni  " hide-footer>
      <div>
          <div class="pt-2 pb-2 text-center">
              <feather-icon icon="AlertCircleIcon" size="80" class="mr-0 mr-sm-50 pb-2" />
              <h4>AVISO</h4>
              <h5>Alumno ya existente en alguna de tus sucursales, búscalo y modifícalo.</h5>
          </div>

          <div>
              <BButton variant="primary" @click="clientMatchModalWarning.hide()">Aceptar</BButton>
          </div>
      </div>
  </BModal>
</div>
</template>

<script>
import { BSidebar, BCol,BFormInvalidFeedback, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BRow, BModal, BCard, BFormRadioGroup, BFormRadio} from 'bootstrap-vue'
import { ref,computed, onUnmounted, inject, watch, toRefs } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import studentModule from '../views/pages/students/studentModule'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import VSelectValidated from '@/components/forms/vSelectValidated.vue'
import axios from '@axios'
import popups from '@/hooks/popups';
import { getPaymentMethods } from '@/composables/paymentMethodService'
import { addAccount } from '@/composables/accountService'
import { addStudent } from '@/composables/studentService'
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';

export default {
  components: { BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BRow, vSelect, DatepickerValidated, ValidationObserver, TextInputValidated, VSelectValidated, BFormInvalidFeedback, BCol, BModal, BCard, BFormRadioGroup, BFormRadio, NumberInputValidated, CheckboxValidated
},
  directives: {
    Ripple,
  },

  emits: ['new-student-added', 'fetchclients', 'new-account-added'] ,
  props: ['parent'],

  setup(props, {emit}) {
    const STUDENTS_MODULE = 'students'
    const { errorToast, successToast } = popups()

    const customer_types=ref([])
    const client = ref({
      dni:'',
      name: '',
      surname: '',
      email: '',
      status: null,
      groups: '',
      province: '',
      country: '',
      address:'',
      bank_account: '',
      billing_nif:null,
      billing_province:null,
      billing_address:null,
      billing_country:null,
      start_date: null,
      end_date: null, 
      password: null,
      is_legal_entity: ''
    })

    
    
    const clientMatchModal=ref(null)
    const clientMatchModalWarning=ref(null)
    const existingclient= ref(false)
    const matchclient = ref(null)
    const showSurnames = ref(true)
    const showIsLegalEntity = ref(false)
    client.value.start_date= new Date(Date.now()).toISOString().split("T")[0]
    
    const { getValidationState } = formValidation()
    
    const clientType = ref('account')

    const clientOptions = ref([
      { text: 'Alumno/a', value: 'student' },
      { text: 'Cuenta', value: 'account' },
    ])
    
    const countries = ref([])
    const provinces = ref([])
    const groups = ref([])
    const states=ref([{label:"Activo", value: "true"}, {label:"Inactivo", value: "false"}, ])
    const paymentMethodsOptions = ref([])

    const fetchPaymentMethods = async function () {
      paymentMethodsOptions.value = (await getPaymentMethods()).data
    }

    fetchPaymentMethods()


/**
 * Comprobar si existe un usuario con el dni introducido
 */
  watch(() => client.value.dni, () => {
    if (clientType.value == 'student') {
      if(client.value.dni.length > 6) {
        axios.post('students/check-dni', { dni: client.value.dni }).then(response => {
            if(response.data.success){
                existingclient.value=true
                if (response.data.msg=="STUDENT_MATCH_GROUP") {
                    matchclient.value = null
                    matchclient.value = response.data.client
                    clientMatchModal.value.show()
                } else if (response.data.msg=="STUDENT_MATCH") {
                    clientMatchModalWarning.value.show()
                }

            } else {
                existingclient.value=false
            }
        })
      }
    }

  }, { deep: true })

  watch(() => client.value.customer_type_id, () => {    
        console.log("entro", client.value.customer_type_id)
        if (client.value.customer_type_id==1 || client.value.customer_type_id==2) {
            client.value.is_legal_entity = false
            showSurnames.value=true
        }
        if (client.value.customer_type_id==3 || client.value.customer_type_id==4) {
            showSurnames.value=false
            client.value.is_legal_entity = true
        }

        if (client.value.customer_type_id==5 || client.value.customer_type_id==6 || client.value.customer_type_id==7) {
            showIsLegalEntity.value=true
            client.value.is_legal_entity = false
        } else {
            showIsLegalEntity.value=false
        }
  })

  watch (() => clientType.value, () => {
    if (clientType.value == "student") {
      showSurnames.value=true      
      // client.value.customer_type_id=null
    }
  })


  
    // sideBar
    const isSidebarActive = inject('isSidebarActive')
    watch(isSidebarActive, () => {
            if(!isSidebarActive.value){
              client.value={
                dni:'',
                name: '',
                surname: '',
                email: '',
                status:'',
                groups: '',
                province: '',
                country: '',
                address:'',
                bank_account: '',
                billing_nif:null,
                billing_province:null,
                billing_address:null,
                billing_country:null,
                start_date: new Date(Date.now()).toISOString(),
                end_date: null
              }
            }
        })

    // Módulos
    if (!store.hasModule(STUDENTS_MODULE)) store.registerModule(STUDENTS_MODULE, studentModule)
      
      onUnmounted(() => { 
        if (store.hasModule(STUDENTS_MODULE)) store.unregisterModule(STUDENTS_MODULE) 
      })

    // Consultas
    store.dispatch('students/createStudent').then(response => {
        groups.value = response.data.groups
        countries.value = response.data.countries
        provinces.value = response.data.provinces
        customer_types.value= response.data.customer_types
      })

    // Métodos
    const submit = function () {
     
      this.$refs.form.validate().then(success => {
        if(success){
            client.value.billing_name = client.value.name
            client.value.billing_first_surname = client.value.first_surname
            client.value.billing_second_surname = client.value.second_surname
            client.value.billing_nif=client.value.dni
            client.value.billing_postal_code=client.value.postal_code
            client.value.billing_province_id=client.value.province_id
            client.value.billing_address=client.value.address
            client.value.billing_country_id=client.value.country_id
            client.value.billing_city=client.value.city


          if (clientType.value=="student") {

            createStudent(client.value)
          } else if (clientType.value =="account") {
            createAccount(client.value)
          }
        }
      })
    }

    const createStudent =  async function (student) {
      student.status = null
      let response = await addStudent(student) 
      console.log(response)
      if(response.success){
        successToast("Estudiante creado correctamente")
        isSidebarActive.value=false
        emit("new-student-added")
      } else {
        if (response.msg=="EXISTING_STUDENT") {
              errorToast("Alumno ya existente")
        } else {
          errorToast("Error")
        }
      }
    }

    const createAccount = async function(account) {
      account.status=1
      let response=await addAccount(account)

      if(response.data.success){
          successToast("Cuenta creada correctamente")
          isSidebarActive.value=false
          emit("new-account-added")
      } else {
          console.log(response.data)
          if (response.data.msg == "INVALID_CIF") {
            errorToast("CIF inválido")
          } else if (response.data.msg == "INVALID_DNI") {
            errorToast("DNI inválido")
          } else if (response.data.msg == "EXISTING_ACCOUNT" ) {
            errorToast("Cuenta ya existente")            
          }
          else {
            errorToast("Error creando cuenta")
          }
      }
    }



    const addToGroup = function(matchclientId) {
            axios.post('students/add-group', { id: matchclientId }).then(response => {
                if(response.status) {
                    clientMatchModal.value.hide()
                    emit('fetchclients')
                    isSidebarActive.value = false
                    successToast('Alumno añadido a la sucursal')
                } 
            })
        }
    
    
    




    return {
      client,
      countries,
      provinces, 
      groups,
      states,
      submit,
      getValidationState,
      isSidebarActive,
      customer_types,
      clientMatchModalWarning,
      clientMatchModal,
      addToGroup,
      matchclient,
      clientOptions,
      clientType,
      paymentMethodsOptions,
      showSurnames,
      showIsLegalEntity
    }


  },

}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
